import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component: HasUnsavedChanges
): boolean | Observable<boolean> => {
  if (!component.hasUnsavedChanges || !component.hasUnsavedChanges()) {
    return true;
  }

  const result$ = new Subject<boolean>();

  const confirmationService = inject(ConfirmationService);
  confirmationService.confirm({
    message: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?',
    header: 'Modifications non enregistrées',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Quitter sans enregistrer',
    rejectLabel: 'Rester sur la page',
    acceptButtonStyleClass: 'p-button-danger',
    accept: () => { result$.next(true); result$.complete(); },
    reject: () => { result$.next(false); result$.complete(); },
  });

  return result$.asObservable();
};
